import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { QueryModelApiConfiguration } from '../apiConfiguration';

import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';

import { PendingAreaFilter } from 'app/shared/models/queryModel/pending-area-filter';
import { ActivePendingArea } from 'app/shared/models/queryModel/active-pending-area';
import { EpisodeType, OrderEpisodeClaimStatus } from 'app/shared/models/queryModel/enums';

@Injectable()
export class PendingAreaService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private activePendingAreaBySearchUrl: string;
    private haveActivePendingAreaForCreditPatientsUrl: string;
    private haveActivePendingAreaForCashPatientsUrl: string;
    private pendingOrderEpisodeStatusUrl: string;
    private checkOrderHasClaimForActiveEpisodeUrl: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.doctorFeesStation.url;
        this.activePendingAreaBySearchUrl = this.actionUrl + _configuration.pendingArea.activePendingAreaBySearch;
        this.haveActivePendingAreaForCreditPatientsUrl = this.actionUrl + _configuration.pendingArea.haveActivePendingAreaForCreditPatients;
        this.haveActivePendingAreaForCashPatientsUrl = this.actionUrl + _configuration.pendingArea.haveActivePendingAreaForCashPatients;
        this.pendingOrderEpisodeStatusUrl = this.actionUrl + _configuration.pendingArea.pendingOrderEpisodeStatus;
        this.checkOrderHasClaimForActiveEpisodeUrl = this.actionUrl + _configuration.pendingArea.checkOrderHasClaimForActiveEpisode;
    }

    getActivePendingAreaBySearch = (pendingAreaFilter: PendingAreaFilter, page: number, rows: number): Observable<ActivePendingArea[]> => {
        const orderId = pendingAreaFilter.OrderId ? pendingAreaFilter.OrderId : '';
        const patientCode = pendingAreaFilter.PatientCode ? pendingAreaFilter.PatientCode : '';
        var orderDateString = pendingAreaFilter.OrderDate ? pendingAreaFilter.OrderDate.toLocaleDateString() : '';
        const patientName = pendingAreaFilter.PatientName ? pendingAreaFilter.PatientName : '';
        const payerTitle = pendingAreaFilter.PayerTitle ? pendingAreaFilter.PayerTitle : '';
        const orderedByName = pendingAreaFilter.OrderedByName ? pendingAreaFilter.OrderedByName : '';
        const location = pendingAreaFilter.Location ? pendingAreaFilter.Location : '';
        // Billing Status now drives which orders appear in the grid. Send 0 (= all order
        // statuses) instead of the legacy New-only status, otherwise @P_STATUS is AND-ed
        // with @P_BILLING_STATUS in ACTIVE_PENDING_AREA_SEARCH and the "Billed" filter
        // (ORDER_STATUS = 2) returns 0 rows. Bug 59312.
        const status = 0;
        const billingStatus = pendingAreaFilter.BillingStatus ? pendingAreaFilter.BillingStatus : '';

        return this._http.get<any>(this.activePendingAreaBySearchUrl
            + '?OrderId=' + orderId
            + '&PatientCode=' + patientCode
            + '&OrderDate=' + orderDateString
            + '&PatientName=' + patientName
            + '&PayerTitle=' + payerTitle
            + '&OrderedByName=' + orderedByName
            + '&Location=' + location
            + '&Page=' + page
            + '&Rows=' + rows
            + '&Status=' + status
            + '&BillingStatus=' + billingStatus
        );
    }

    haveActivePendingAreaForCreditPatients = (): Observable<boolean> => {
        return this._http.get<any>(this.haveActivePendingAreaForCreditPatientsUrl);
    }

    haveActivePendingAreaForCashPatients = (): Observable<boolean> => {
        return this._http.get<any>(this.haveActivePendingAreaForCashPatientsUrl);
    }

    pendingOrderEpisodeStatus = (orderId: number): Observable<EpisodeType> => {
        return this._http.get<EpisodeType>(`${this.pendingOrderEpisodeStatusUrl}?orderId=${orderId}`);
    }

    checkOrderHasClaimForActiveEpisode = (encounterId: number): Observable<OrderEpisodeClaimStatus> => {
        return this._http.get<OrderEpisodeClaimStatus>(`${this.checkOrderHasClaimForActiveEpisodeUrl}?encounterId=${encounterId}`);
    }

}

